import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const useShopStore = create(
  persist(
    (set) => ({
      selectedShop: null,
      availableShops: [],

      setSelectedShop: (shop) => {
        set({ selectedShop: shop });
      },

      setAvailableShops: (shops) => {
        set({ availableShops: shops });
      },

      clearShop: () => {
        set({ selectedShop: null, availableShops: [] });
      },
    }),
    {
      name: 'shop-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        selectedShop: state.selectedShop,
        availableShops: state.availableShops,
      }),
    }
  )
);

export default useShopStore;
